export default __webpack_public_path__ + "static/stats_1-4d4bf76763c54545a479ff333078f061.png";